var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NMarker',{attrs:{"position":_vm.position,"zIndex":_vm.zIndex},on:{"click":function () { return _vm.$emit('click', _vm.delivery); }}},[_c('DeliveryStatusMarker',{attrs:{"showNumbers":_vm.showNumbers,"deliveryEvent":_vm.delivery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }